import React from "react";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";

import CondicionEditor from "./condicion-editor";
import { condicionVacia, describirGrupo } from "./filter-registry";

/**
 * Lista de condiciones que se combinan con Y, más el resumen en texto de lo armado.
 */
const GrupoCondiciones = ({
  condiciones = [],
  onChange,
  opcionesApi,
  titulo = "Condiciones",
  descripcion,
}) => {
  const handleCondicion = (indice, condicion) => {
    const temp = [...condiciones];
    temp[indice] = condicion;
    onChange(temp);
  };

  const handleRemove = (indice) => {
    onChange(condiciones.filter((_, i) => i !== indice));
  };

  const resumen = describirGrupo(condiciones, opcionesApi);

  return (
    <div>
      <label className="admin-label-text d-block">{titulo}</label>
      {descripcion && (
        <div className="admin-muted-text-small mb-2">{descripcion}</div>
      )}

      {condiciones.map((condicion, indice) => (
        <CondicionEditor
          key={indice}
          condicion={condicion}
          onChange={(nueva) => handleCondicion(indice, nueva)}
          onRemove={() => handleRemove(indice)}
          opcionesApi={opcionesApi}
        />
      ))}

      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={() => onChange([...condiciones, condicionVacia()])}
      >
        Agregar condición
      </Button>

      {resumen && (
        <div className="admin-muted-text-small mt-2">
          Resultado: {resumen}
        </div>
      )}
    </div>
  );
};

export default GrupoCondiciones;
